<template>
    <index-table
        :cols="[
            {
                value: 'serial_number',
                label: 'Radio SN',
                searchable: true,
                sortable: true,
            },
            {
                value: 'latest_health_check_at',
                label: 'Last Response',
                searchable: true,
                sortable: true,
                customCell: 'RelayRadioLastResponseCell',
            },
            {
                label: 'Status',
                searchable: false,
                sortable: false,
                customCell: 'RelayRadioStatusCell',
            },
        ]"
        :disableMultiSelect="true"
        :options="options"
        :optionsComponent="optionsComponent"
        :title="'Relay Management'"
        alignCells="middle"
        data-test-id="relays-table"
        defaultSort="latest_health_check_at"
        defaultDir="desc"
        model="asset-radios"
    >
        <template #create>
            <create-asset-menu />
        </template>
        <template #navigation>
            <div class="tabs">
                <button
                    data-test-id="relays-table-button"
                    @click="goToRelays"
                >
                    Relays
                </button>
                <button
                    class="active"
                    data-test-id="relay-radios-table-button"
                    @click="goToRelayRadios"
                >
                    Radios
                </button>
            </div>
        </template>
    </index-table>
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import CreateAssetMenu from '@/components/CreateAssetMenu.vue'

export default {
    components: {
        CreateAssetMenu,
        IndexTable,
    },

    mixins: [needsOrganizationSlug],

    data() {
        let selectedOrganizationId = null

        if (this.$route.query.organization_id) {
            selectedOrganizationId = parseInt(this.$route.query.organization_id, 10)
        }
        return {
            selectedOrganizationId,
            optionsComponent: 'RelayRadioActions',
        }
    },

    computed: {
        options() {
            const result = []
            const { hasPermission } = this.$store.getters

            if (hasPermission('update assets')) {
                result.push('editable')
            }

            if (hasPermission('upload assets')) {
                result.push('importable')
            }

            return result
        },
    },

    methods: {
        goToRelays() {
            this.$router.push(`/${this.organizationSlug}/relays`)
        },

        goToRelayRadios() {
            this.$router.push(`/${this.organizationSlug}/relays/radios`)
        },
    },
}
</script>
<style lang="scss">
.tabs {
    padding: 0px;
    margin: 0px;

    button {
        border: 1px solid #888;
        color: #fff;
        font-size: 14px;
        background-color: transparent;
        padding: 10px 12px;
        width: 256px;
        height: 40px;
        cursor: pointer;
    }

    .button:first-child {
        border-radius: 8px 0px 0px 8px;
    }

    button:not(:last-child) {
        border-right-width: 0px;
    }

    button:last-child {
        border-radius: 0px 8px 8px 0px;
    }

    button.active {
        background-color: #212628;
    }
}
</style>
